import request from "./../utils/request";
import _ from "lodash";

export function getUserInfo(id) {
    return request({
        url: `/users/${id}`,
        method: "get",
    });
}

export function loadOldConversations(visitorId) {
    return request({
        url: `/visitors/${visitorId}/conversations`,
        method: "get",
    });
}

export function addNoteToConversation(conversationId, representativeNote, representativeName) {
    return request({
        url: `/conversations/${conversationId}/note`,
        method: "post",
        data: {
            representativeName,
            representativeNote,
        },
    });
}

export function loadOldConversationsAsPaged(visitorId, page, perPage, conversationId) {
    if (conversationId)
        return request({
            url: `/visitors/${visitorId}/conversations-paged?page=${page}&perpage=${perPage}&conversationId=${conversationId}`,
            method: "get",
        });
    return request({
        url: `/visitors/${visitorId}/conversations-paged?page=${page}&perpage=${perPage}`,
        method: "get",
    });
}

export function updateCustomLoginInfos(conversationId, customLoginInfos) {
    return request.put(`/conversations/${conversationId}/update-single-key`, {
        key: "customLoginInfos",
        value: customLoginInfos,
    });
}

export function loadOldMessages(conversationId, fetchHistory = false) {
    return request({
        url: `/conversations/${conversationId}/messages?all=${fetchHistory}`,
        method: "get",
        timeout: 3000,
    });
}

export function loadChatHistory(conversationId, page, pageSize, cachedChatIds, ts) {
    const cachedChatIdsString = cachedChatIds.map((id) => `c=${id}`).join("&");
    return request({
        url: `/conversations/${conversationId}/message-history?page=${page}&pageSize=${pageSize}&ts=${ts}&${cachedChatIdsString}`,
        method: "get",
    });
}

export function loadChatHistoryV2(conversationId, offset, limit, cachedChatIds, ts) {
    const cachedChatIdsString = cachedChatIds.map((id) => `c=${id}`).join("&");
    return request({
        url: `/conversations/${conversationId}/v2-message-history?offset=${offset}&limit=${limit}&ts=${ts}&${cachedChatIdsString}`,
        method: "get",
        //timeout=1min
        timeout: 3000,
    });
}

export function updateConversationTags(conversationId, tagIds) {
    return request.post(`/conversations/${conversationId}/tags`, { tagIds });
}

export function getContactList(pageCount, perPage, searchValue) {
    return request.get(`/conversations/contact-list/${pageCount}/${perPage}`, {
        params: {
            query: searchValue,
        },
    });
}

export function getContactListByChannel(channel, pageCount, perPage, searchValue) {
    return request.get(`/conversations/contact-list-by-channel/${channel}/${pageCount}/${perPage}`, {
        params: {
            query: searchValue,
        },
    });
}

export function getContactListByChannels(channelIds, pageCount, perPage, searchValue, platform) {
    channelIds = channelIds.join(",");
    channelIds = _.compact(channelIds.split(","));
    return request.get(
        `/conversations/contact-list-by-channels?channelIds=${channelIds}&pageCount=${pageCount}&perPage=${perPage}&searchValue=${searchValue}&platform=${platform}`
    );
}

export function getWhatsappContactList(channelId, pageCount, perPage, query) {
    return request
        .get(`/conversations/contact-list/whatsapp`, {
            params: {
                query,
                perPage,
                pageCount,
                channel: channelId,
            },
        })
        .then((res) => res.data);
}

export function getContactListNullChannel(pageCount, perPage) {
    return request.get(`/conversations/contact-list-null-channel/${pageCount}/${perPage}`);
}

export function transferFlowlu(conversationId, visitorId) {
    return request.post(`/conversations/transfer-flowlu`, {
        conversationId,
        visitorId,
    });
}

export function getConversationList(payload) {
    try {
        payload.filters.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        payload.filters.tz = "Europe/Istanbul";
    }

    return request.post(`/contacts`, payload);
}

export function getContactListStats(filters) {
    return request.post(`/contacts/stats`, filters);
}

export function getContactById(id, ignoreSource) {
    return request.get(`/contacts/${id}?ignoreSource=${ignoreSource}`);
}

export function getChatsOverview() {
    return request.get(`/conversations/conversation-stat-realtime`).then((res) => res.data);
}

export function searchMessages(searchQuery) {
    return request
        .post(`/messages/search-messages`, {
            searchQuery,
        })
        .then((res) => res.data);
}
